// add in local storage keys here

export const LOCAL_STORAGE_KEYS = {
  // save after submitting form
  QUOTE_REQUEST_ID: "quote_request_id",

  // used while filling out form, removed on submission
  UPLOADED_QUOTE: "uploaded_quote",
  QUOTE_DETAILS: "quote_details",
  QUOTE_QUESTIONS: "quote_questions",
  LOAN_INFO: "loan_info",
  REFI_BUDDY_DATA: "refi_buddy_data",
};
